import React, { Component } from 'react';

import HomePage from '../HomePage/HomePage';
import Inquire from '../Inquire/Inquire';

import '../../assets/styles/fonts.scss';
import Header from '../../components/Common/Header/Header'
import Footer from '../../components/Common/Footer/Footer';

import { Route, Switch } from "react-router-dom";

import './App.scss';

class App extends Component {
  render() {
    return (
        <div className="App">
          <Header />
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route exact path="/apply" component={Inquire} />
          </Switch>
          <Footer />
        </div>
    );
  }
}

App.propTypes = {

};

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/App.js